import { baseServiceRequest } from "@apis/baseServiceRequest"
import type { IBasePtc, IMarketCurrentPtc, IMarketRate } from "./types"

export const getMarketCurrentPtc = async (
  market_code: string,
  revenue_class_code: string,
): Promise<IMarketCurrentPtc> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/pricing/rates/ptc/market/${market_code}/${revenue_class_code}`,
  })
  return response.data
}

export const getPtcHistory = async (
  market_code: string,
  revenue_class_code: string,
): Promise<IBasePtc[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/pricing/rates/ptc/all/market/${market_code}`,
    params: {
      revenue_class_code,
    },
  })
  return response.data
}

export const getMarketRates = async (
  market_code: string,
): Promise<IMarketRate[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/pricing/market_rates/${market_code}`,
  })
  return response.data
}
